import fetch from 'auth/FetchInterceptor'
import { ADMIN_API_BASE_ENDPOINT, DEMO_SERVER_ENDPOINT } from 'configs/AppConfig'
const JwtAuthService = {}

JwtAuthService.login = function (data) {

	return fetch({
		url: ADMIN_API_BASE_ENDPOINT + 'user/login',
		method: 'post',
		headers: {
      		//'public-request': 'true',
			//'Content-Type': 'application/json'
		},
		data: data
	})
}

JwtAuthService.logout = function (data) {

	return fetch({
		url: ADMIN_API_BASE_ENDPOINT + 'admin/admin_logout',
		method: 'post',
		headers: {
      		//'public-request': 'true',
			'Content-Type': 'application/json'
		},
		data: data
	})
}

JwtAuthService.signUp = function (data) {
	return fetch({
		url: '/auth/signup',
		method: 'post',
		headers: {
			'public-request': 'true'
		},
			data: data
		})
}

JwtAuthService.demoServerGet = function (route,data) {
	return fetch({
	url: DEMO_SERVER_ENDPOINT + route,
	method: 'get',
	headers: {
		// 'public-request': 'true'
	},
	params: data
	})
}
JwtAuthService.demoServerPost = function (route,data) {
	return fetch({
		url: DEMO_SERVER_ENDPOINT + route,
		method: 'post',
		headers: {
			// 'public-request': 'true'
		},
		data: data
		})
}
JwtAuthService.demoServerDelete = function (route) {
	return fetch({
		url: DEMO_SERVER_ENDPOINT + route,
		method: 'DELETE',
		headers: {
			// 'public-request': 'true'
		},
	})
}

export default JwtAuthService